import React, { useEffect, useState } from 'react'

import styles from './AnimatedCheckmark.module.scss'

const AnimatedCheckmark: React.FC = () => {
  const [radius, setRadius] = useState(0)

  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      setRadius(12)
    })

    return () => cancelAnimationFrame(frame)
  }, [])

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r={radius} fill="#5DDFB1" className={styles.circle} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4032 7.39684C17.8741 6.86772 17.0186 6.86772 16.4894 7.39684L9.9139 13.9724L7.31065 11.3691C6.78153 10.84 5.92596 10.84 5.39684 11.3691C4.86772 11.8982 4.86772 12.7538 5.39684 13.2829L8.96196 16.8481C9.49108 17.3772 10.3468 17.377 10.8759 16.8479L18.4032 9.31065C18.9324 8.78153 18.9324 7.92596 18.4032 7.39684Z"
        fill="white"
      />
    </svg>
  )
}

export default AnimatedCheckmark
